<template>
  <div class="">
    <BobDisplayForm
      :config="{
        rowGap: 12,
        labelWidth: '150px',
      }"
      :fields="displayFields"
    />
  </div>
</template>

<script>
import BobDisplayForm from '@/components/BobDisplayForm.vue'
import { get } from 'lodash'
import { defineComponent, computed } from 'vue'
export default defineComponent({
  name: 'KeeperVehicleInfoBlock',
  components: {
    BobDisplayForm,
  },
  props: {
    orderData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props, { emit }) {
    const displayFields = computed(() => {
      const fields = [
        // 診所
        {
          prop: 'size',
          label: '尺寸',
          body: {
            component: 'div',
            render: () => {
              const size = get(props.orderData, 'AppointmentOrder.customInfo.keeperVehicle.size')
              return size
            },
          },
        },
        // 車牌號碼
        {
          prop: 'plate',
          label: '車牌',
          body: {
            component: 'div',
            render: () => {
              const plate = get(props.orderData, 'AppointmentOrder.customInfo.keeperVehicle.plate')
              return plate
            },
          },
        },
        // 品牌
        {
          prop: 'brand',
          label: '品牌',
          body: {
            component: 'div',
            render: () => {
              const brand = get(props.orderData, 'AppointmentOrder.customInfo.keeperVehicle.brandName')
              return brand || '-'
            },
          },
        },
        // 型號
        {
          prop: 'model',
          label: '型號',
          body: {
            component: 'div',
            render: () => {
              const model = get(props.orderData, 'AppointmentOrder.customInfo.keeperVehicle.typeName')
              return model || '-'
            },
          },
        },
      ]
      return fields
    })

    return {
      displayFields,
    }
  },
})
</script>

<style lang="postcss" scoped>

</style>
